import React from "react";
import { ListStateIcon } from "../ListStateIcon/ListStateIcon";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

interface IListStateIconNotStartedProps {
  noMargin?: boolean;
  color?: string;
  tooltip?: string;
}

export const ListStateIconNotStarted = (props: IListStateIconNotStartedProps) => (
    <ListStateIcon
        icon={HourglassTopIcon}
        tooltip={props.tooltip}
        color={props.color}
        noMargin={props.noMargin}
    />
);
